import Vue from "vue";
import PeopleSearchWidget from "./components/PeopleSearch.vue";
import Vuex from "vuex";
import PeopleSearchWidgetState from "@/apps/PeopleSearchWidget/models/people-search-widget-state";
import actions from "@/apps/PeopleSearchWidget/store/actions"
import mutations from "@/apps/PeopleSearchWidget/store/mutations"
import getters from "@/apps/PeopleSearchWidget/store/getters"
import {root} from "@/shared/store";

Vue.config.productionTip = false;
Vue.use(Vuex)

let PeopleSearchWidgets = document.querySelectorAll('widget-people-search');
if (PeopleSearchWidgets.length) {
    PeopleSearchWidgets.forEach(el => {

        let store = new Vuex.Store({
            state: new PeopleSearchWidgetState,
            actions: actions,
            mutations: mutations,
            getters: getters,
            modules: {
                root
            }
        })

        new Vue({
            el: el,
            store,
            render(h: any) {
                let language = this.$el.attributes.getNamedItem('language');
                let index = this.$el.attributes.getNamedItem('index');
                let resultsPerPage = this.$el.attributes.getNamedItem('results-per-page');
                let resultsOrder = this.$el.attributes.getNamedItem('results-order');
                let endpoint = this.$el.attributes.getNamedItem('endpoint');
                let labels = this.$el.attributes.getNamedItem('labels');

                return h(PeopleSearchWidget, {
                    props: {
                        configRaw: {
                            language: language ? language.value : null,
                            index: index ? index.value : null,
                            resultsPerPage: resultsPerPage ? resultsPerPage.value : null,
                            resultsOrder: resultsOrder ? resultsOrder.value : null,
                            endpoint: endpoint ? endpoint.value : null,
                            labels: labels ? JSON.parse(labels.value) : null
                        }
                    }
                });
            }
        });
    });
}
